import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Home as HomeIcon, BedDouble, ArrowRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { CITIES, TYPES } from "../../mock";

export default function EstimateBar({ compact = false, defaultCity = "Saint-Malo" }) {
  const nav = useNavigate();
  const [city, setCity] = useState(defaultCity);
  const [type, setType] = useState("appartement");
  const [bedrooms, setBedrooms] = useState("2");

  const go = (e) => {
    e.preventDefault();
    nav(`/proprietaires?city=${encodeURIComponent(city)}&type=${type}&bedrooms=${bedrooms}`);
  };

  const field = "h-14 border-0 shadow-none bg-transparent px-0 text-[15px] font-semibold text-[#13261c] focus:ring-0 focus:ring-offset-0";

  return (
    <form onSubmit={go} data-testid="estimate-bar"
      className={`bg-white rounded-[28px] p-2.5 shadow-[0_30px_60px_-25px_rgba(19,38,28,0.45)] ring-1 ring-[#13261c]/5 grid gap-1 ${compact ? "" : "sm:grid-cols-3"} items-center`}>
      <label className="flex items-center gap-3 px-4 rounded-2xl hover:bg-[#f1ebdd]/60 transition-colors">
        <MapPin className="w-5 h-5 text-[#c4703f] shrink-0" />
        <div className="flex-1">
          <span className="block text-[11px] uppercase tracking-wider font-bold text-[#6d7268] pt-2">Ville</span>
          <Select value={city} onValueChange={setCity}>
            <SelectTrigger className={`${field} h-8 pb-2`} data-testid="estimate-city"><SelectValue /></SelectTrigger>
            <SelectContent>{CITIES.map((c) => <SelectItem key={c.name} value={c.name}>{c.name}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </label>
      <label className="flex items-center gap-3 px-4 rounded-2xl hover:bg-[#f1ebdd]/60 transition-colors sm:border-l border-[#e6dcc8]">
        <HomeIcon className="w-5 h-5 text-[#c4703f] shrink-0" />
        <div className="flex-1">
          <span className="block text-[11px] uppercase tracking-wider font-bold text-[#6d7268] pt-2">Type de bien</span>
          <Select value={type} onValueChange={setType}>
            <SelectTrigger className={`${field} h-8 pb-2`} data-testid="estimate-type"><SelectValue /></SelectTrigger>
            <SelectContent>{TYPES.map((t) => <SelectItem key={t.id} value={t.id}>{t.label}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </label>
      <label className="flex items-center gap-3 px-4 rounded-2xl hover:bg-[#f1ebdd]/60 transition-colors sm:border-l border-[#e6dcc8]">
        <BedDouble className="w-5 h-5 text-[#c4703f] shrink-0" />
        <div className="flex-1">
          <span className="block text-[11px] uppercase tracking-wider font-bold text-[#6d7268] pt-2">Chambres</span>
          <Select value={bedrooms} onValueChange={setBedrooms}>
            <SelectTrigger className={`${field} h-8 pb-2`} data-testid="estimate-bedrooms"><SelectValue /></SelectTrigger>
            <SelectContent>{["1", "2", "3", "4", "5"].map((b) => <SelectItem key={b} value={b}>{b === "5" ? "5 et +" : b} chambre{b !== "1" ? "s" : ""}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </label>
      <button type="submit" data-testid="estimate-submit"
        className="group sm:col-span-3 mt-1 h-14 rounded-[22px] bg-[#13261c] hover:bg-[#2a4636] text-white font-bold px-6 whitespace-nowrap inline-flex items-center justify-center gap-2 transition-colors">
        Découvrir mon potentiel locatif <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
      </button>
    </form>
  );
}
